import GatewayBase from './gateway-base';

export type BrowseAppsParams = {
  search?: string;
  category?: string;
};

export default class MarketplaceRestService extends GatewayBase {
  browseApps = (storeId: string, params?: BrowseAppsParams) => {
    return this.client.get(`/v1/stores/${storeId}/marketplace`, { params });
  };

  listPrivateApps = (storeId: string) => {
    return this.client.get(`/v1/stores/${storeId}/marketplace`, { params: { scope: 'private' } });
  };

  getApp = (storeId: string, appId: string) => {
    return this.client.get(`/v1/stores/${storeId}/marketplace/${appId}`);
  };

  listInstalledApps = (storeId: string) => {
    return this.client.get(`/v1/stores/${storeId}/apps`);
  };

  installApp = (storeId: string, applicationId: string, scopes: string[]) => {
    return this.client.post(`/v1/stores/${storeId}/apps/install`, { applicationId, scopes });
  };

  uninstallApp = (storeId: string, installationId: string) => {
    return this.client.delete(`/v1/stores/${storeId}/apps/${installationId}`);
  };

  reauthorizeApp = (storeId: string, installationId: string, scopes: string[]) => {
    return this.client.post(`/v1/stores/${storeId}/apps/${installationId}/reauthorize`, { scopes });
  };

  createSessionToken = (storeId: string, installationId: string) => {
    return this.client.post(`/v1/stores/${storeId}/apps/${installationId}/session`);
  };
}
